/*
 * @Author: liyxt
 * @Date: 2020-05-28 14:28:27
 * @LastEditors: liyxt
 * @LastEditTime: 2020-06-04 11:26:35
 * @Description: file content
 */ 
import React, { Component } from 'react';
import OriginCarousel from 'bee-carousel';
require('bee-carousel/build/Carousel.css');

export default class Carousel extends Component {
    render() {
        return <OriginCarousel {...this.props} />;
    }
}
